import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Icon from "../Elements/Icon/Icon";
import Images from "../../constant/images";
import "./TestimonialCarousel.css";

const testimonials = [
  {
    name: "Mohd Manzoor",
    title: "Talent Acquisition Specialist",
    text: "Almaaly has been an invaluable partner in our talent acquisition journey. Their dedication, expertise, and personalized approach have consistently delivered high-caliber candidates who align with our organization's culture and values. We look forward to continuing our successful partnership.",
  },
  {
    name: "Mohd Ibrahim",
    title: "HR Manager",
    text: "The team has delivered invaluable service.  Almaaly’s expertise and dedication have consistently delivered high-caliber candidates, resulting in successful placements that have driven our business growth. We highly recommend their recruitment services.",
  },
  {
    name: "Syed Qureshi",
    title: "General Manager – HR",
    text: "Almaaly team has exceeded our expectations with their proactive approach, industry expertise, and exceptional candidate sourcing. Their hiring solutions saved us time and resources, allowing us to focus on our core business. Great job!",
  },
  {
    name: "Ayesha Khan",
    title: "Senior Recruiter",
    text: "Their team has played a crucial role in our hiring success...",
  },
  {
    name: "Rohit Sharma",
    title: "Business Consultant",
    text: "A very professional and efficient service. Highly recommended...",
  },
];

export default function TestimonialCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width: 900px)");
  const visibleCards = isMobile ? 1 : 3;

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setActiveIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length
    );
  };

  const displayedTestimonials = testimonials.slice(
    activeIndex,
    activeIndex + visibleCards
  ).length < visibleCards
    ? [
        ...testimonials.slice(activeIndex),
        ...testimonials.slice(0, visibleCards - (testimonials.length - activeIndex)),
      ]
    : testimonials.slice(activeIndex, activeIndex + visibleCards);

  return (
    <Box textAlign="center" sx={{ mx: isMobile ? 0 : 5, mt: 8 }}>
      <Typography variant="h4" className="pp" mb={6} mt={4}>
        We’re Trusted Across Industries
      </Typography>

      <Box display="flex" alignItems="center" gap={isMobile ? 0 : 2}>
        <IconButton onClick={prevSlide} style={{ color: "black" }}>
          <ChevronLeftIcon
            sx={{ fontSize: isMobile ? "25px !important" : "40px !important" }}
          />
        </IconButton>

        <Box display="flex" gap={2} overflow="hidden" width="100%">
          {displayedTestimonials.map((t, index) => (
            <Card
              key={index}
              sx={{
                p: 3,
                flex: 1,
                maxWidth: index === 1 ? 557 : 300,
                height: index === 1 ? 255 : 210,
                backgroundColor:
                  isMobile || index === 1 ? "#721372" : "#FFFFFF",
                color: isMobile || index === 1 ? "white" : "text.primary",
                    transition: "background-color 0.3s ease",
                    // position: "relative",
                    textAlign: "left",
                boxShadow:
                  isMobile || index === 1
                    ? ""
                    : "5px 5px 5px 5px #0000004F",
                margin: isMobile || index === 1 ? "" : "20px",
                // position: "relative",
              }}
            >
              {(isMobile || index === 1) && (
                <Icon
                  src={Images.tsm}
                  style={{
                    position: "absolute",
                    left: isMobile ? "86%" : "60%",
                        width: isMobile ? "40px" : "", // ✅ Adjust size for mobile
                    height: isMobile ? "40px" : "60px",
                    marginTop: isMobile ? "-20px" : "-10px",
                        transform: "translate(-50%, -50%)", // Center above the card
                        fontSize: 50, // Increase size if needed
                        color: "white",
                        zIndex: 2, // Ensure it stays visible
                  }}
                  alt=""
                />
              )}

              <Typography
                variant="h6"
                mt={index === 1 ? 5 : ""}
                className={
                  isMobile || index === 1
                    ? "active-ts-tittle1"
                    : "ts-tittle1"
                }
              >
                {t.name}
              </Typography>
              <Typography
                variant="subtitle1"
                mt={index === 1 ? 0.5 : ""}
                className={
                  index === 1 ? "active-ts-tittle2" : "ts-tittle2"
                }
              >
                {t.title}
              </Typography>
              <Typography
                variant="body2"
                mt={index === 1 ? 1 : ""}
                className={
                  index === 1 ? "active-ts-paragraph" : "ts-paragraph"
                }
              >
                {t.text}
              </Typography>
            </Card>
          ))}
        </Box>

        <IconButton
          onClick={nextSlide}
          style={{ color: "black", fontSize: "40px !important" }}
        >
          <ChevronRightIcon
            sx={{ fontSize: isMobile ? "25px !important" : "40px !important" }}
          />
        </IconButton>
      </Box>
    </Box>
  );
}
